import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ApplicationTypesList from './ApplicationTypesList/ApplicationTypesList';
import ApplicationTypeCreate from './ApplicationTypeCreate/ApplicationTypeCreate';
import ApplicationTypeEdit from './ApplicationTypeEdit/ApplicationTypeEdit';
import ApplicationTypeDelete from './ApplicationTypeDelete/ApplicationTypeDelete';

const ApplicationTypes = ({ match }) => {
    return (
        <div className="ApplicationTypes">
            <ContainerWrapper container="applicationTypes">
                <Route exact path={ match.path } component={ApplicationTypesList} />
                <Route exact path={ `${ match.url }/new` } component={ApplicationTypeCreate} />
                <Route exact path={ `${ match.url }/edit/:applicationTypeId` } component={ApplicationTypeEdit} />
                <Route exact path={ `${ match.url }/delete/:applicationTypeId` } component={ApplicationTypeDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default ApplicationTypes;

